import apiClient from "utils/ApiClient";
import { SITES } from "configurations/Urls";

const PlantedAcresService = {
  async getPlantedAcresBySiteId(siteId, params, signal) {
    const response = await apiClient.get(
      `${SITES}/${siteId}/planted-crops?${params}`,
      { signal }
    );
    return response.data;
  },

  async addPlantedAcres(siteId, plantedAcres) {
    const response = await apiClient.post(
      `${SITES}/${siteId}/planted-crops`,
      plantedAcres
    );
    return response.data;
  },

  async updatePlantedAcres(siteId, plantedAcresId, plantedAcres) {
    const response = await apiClient.put(
      `${SITES}/${siteId}/planted-crops/${plantedAcresId}`,
      plantedAcres
    );
    return response.data;
  },

  async deletePlantedAcres(siteId, plantedAcresId) {
    const response = await apiClient.delete(
      `${SITES}/${siteId}/planted-crops/${plantedAcresId}`
    );
    return response.data;
  },

  async getTimelineDataByPlantedAcresId(siteId, plantedAcresId) {
    const response = await apiClient.get(
      `${SITES}/${siteId}/planted-crops/${plantedAcresId}/timeline`
    );
    return response.data;
  },

  async getCropOptions() {
    const response = await apiClient.get(`${SITES}/planted-crops/options`);
    return response.data;
  },
};
export default PlantedAcresService;
